import React from 'react';

const LoadingSkeletonList = () => {
  return (
    <main className="container mb-5 mt-2">
      {/* Placeholder per i dropdown */}
      <div className="d-flex justify-content-end gap-3 mt-2 me-2">
        <div className="skeleton-button pulse" style={{ width: '100px' }} />
        <div className="skeleton-button pulse" style={{ width: '100px' }} />
      </div>

      {/* Placeholder per il titolo e sottotitolo */}
      <section className="mt-4">
        <div className="skeleton-title pulse" style={{ width: '300px', height: '32px' }} />
        <div className="skeleton-line pulse" style={{ width: '200px', marginBottom: '2rem' }} />
      </section>

      {/* Placeholder per le card dei POI */}
      <section>
        <ul className="list-group mb-5">
          {[1, 2, 3, 4, 5].map((item) => (
            <li key={item} className="list-group-item list-group-item-divider">
              <div className="w-100 p-0">
                {/* Placeholder per l'immagine */}
                <div className="skeleton-image pulse" style={{ height: '250px' }} />
                
                {/* Placeholder per il contenuto della card */}
                <div className="py-3">
                  {/* Categoria */}
                  <div className="d-flex justify-content-start mb-1">
                    <div className="skeleton-line pulse" style={{ width: '150px' }} />
                  </div>

                  {/* Titolo */}
                  <div className="skeleton-title pulse mb-2" style={{ width: '80%' }} />

                  {/* Indirizzo */}
                  <div className="skeleton-line pulse mb-2" style={{ width: '60%' }} />

                  {/* Distanza e bottone */}
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="skeleton-line pulse" style={{ width: '100px' }} />
                    <div className="skeleton-button pulse" style={{ width: '120px' }} />
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </section>
    </main>
  );
};

export default LoadingSkeletonList;